
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/open-finance",
      function () {
        return require("private-next-pages/open-finance.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/open-finance"])
      });
    }
  